import styled from '@emotion/styled';

import {
 RedBgButton,
 RedBorderButton,
} from '../../../components/Button/Buttons';
import { useNavigate } from 'react-router-dom';
import { GLOBAL_IMPORTS, IMPORT_FROM_CHINA } from '../../../routes/routeConstants';

const NewSegment = () => {
 const navigate = useNavigate();
 return (
  <SegmentContentWrapper>
   <H1>Save more on bulk imports to Nigeria</H1>
   <Descriptions>
    CML offers fast, reliable shipping from China to Nigeria. Get your
    international items delivered to Nigeria fast with CML.
   </Descriptions>
   <ButtonArea>
    <RedBgButton onClick={() => navigate(`${GLOBAL_IMPORTS}`)}>
     Global Imports
    </RedBgButton>
    <RedBorderButton onClick={() => navigate(`${IMPORT_FROM_CHINA}`)}>
     Chinese Imports
    </RedBorderButton>
   </ButtonArea>
  </SegmentContentWrapper>
 );
};

export default NewSegment;

const SegmentContentWrapper = styled.div`
 display: flex;
 flex-direction: column;
 justify-content: center;
 line-height: 78px;
 gap: 28px;
 width: 611px;
`;

const H1 = styled.h1`
 font-size: 55px;
 font-weight: 700;

 @media (max-width: 884px) {
  font-size: 44px;
  line-height: 57.2px;
 }

 @media (max-width: 480px) {
  font-size: 30px;
  line-height: 36px;
 }
`;

const Descriptions = styled.div`
 font-size: 20px;
 font-weight: 500;
 line-height: 28px;
 color: rgba(0, 0, 0, 1);

 @media (max-width: 884px) {
  font-size: 18px;
  line-height: 22.5px;
 }
`;

const ButtonArea = styled.div`
 display: flex;
 align-items: center;
 gap: 24px;

 @media (max-width: 884px) {
  gap: 20px;
 }
`;
